
import axios, { AxiosResponse } from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";
import GlobalConfig from "@/GlobalConfig";
import WsdlService from "@/services/WsdlService";
import Option from "@/models/SelectOption";
import FundTypeObj from "@/models/WsdlResponses/FundTypeObj";
import FundType from "@/models/WsdlResponses/FundType";
import UmbracoApiService from "@/services/UmbracoApiService";
import MiInversionModel from "@/models/MiInversion/MiInversionModel";
@Component({})
export default class MiInversionForm extends Vue {
	@Prop() isProcessing: boolean;
	
    public tiposDeFondos: Array<Option<FundType>> = [];
    public tipoFondo: FundType = new FundType();
	public todaysDate: Date = new Date();
    public wsdlService: WsdlService = new WsdlService();
	public toDate: string = "";
    public userId: string = this.$store.state.user.cedula;

    constructor() {
        super();
    }

    public umbracoService = new UmbracoApiService();
    public miInversion = new MiInversionModel();

    async mounted() {
        await this.getData();
        await this.getDropdownData();
    }
    async getDropdownData() {
        this.wsdlService
            .getTipoDeFondos(this.userId, "")
            .then((response: AxiosResponse<FundTypeObj>) => {
                let option = new Option<FundType>();
                option.value = response.data.tipofondos;
                option.text = response.data.tipofondos.valor;
                option.disabled = false;
                this.tiposDeFondos.push(option);
                this.tipoFondo = option.value;
            });
    }
    async getData() {
        this.miInversion = await this.umbracoService.getMiInversion();
    }
    public process() {
        this.$emit("process", this.tipoFondo, this.toDate);
    }
	returnHome() {
        window.location.href = GlobalConfig.PORTAL_BASE_URL
    }
	public setToDate(date: string) {
		let partitionedDateString = date.split('-');
        this.toDate = `${partitionedDateString[2]}/${partitionedDateString[1]}/${partitionedDateString[0]}`;
    }
}
